import React, { useState, useEffect } from "react";
import { Container, Alert } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import NewAdmin from "./NewAdmin";
import AdminList from "./AdminList";

const Admins = () => {
  document.title = "Admins | mrmto";

  const [activeButton, setActiveButton] = useState(false);
  const [refreshList, setRefreshList] = useState(0);
  const [notification, setNotification] = useState({
    show: false,
    type: "",
    message: "",
  });

  // Clear notification after 3 seconds
  useEffect(() => {
    if (notification.show) {
      const timer = setTimeout(() => {
        setNotification({ show: false, type: "", message: "" });
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [notification.show]);

  const handleCreateSuccess = () => {
    setActiveButton(false);
    setNotification({
      show: true,
      type: "success",
      message: "Admin created successfully!",
    });
    // Trigger refresh of admin list
    setRefreshList((prev) => prev + 1);
  };

  const handleCancelCreate = () => {
    // Just switch back to list view without showing any notification
    setActiveButton(false);
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="mrmto" breadcrumbItem="Admins" />

          {notification.show && (
            <Alert color={notification.type} className="mb-4">
              {notification.message}
            </Alert>
          )}

          {!activeButton ? (
            <div>
              <div className="d-flex justify-content-end mb-3">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => setActiveButton(true)}>
                  New Admin
                </button>
              </div>
              <AdminList key={`admin-list-${refreshList}`} />
            </div>
          ) : (
            <NewAdmin
              onSuccess={handleCreateSuccess}
              onCancel={handleCancelCreate}
            />
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Admins;
